<script>
    export default {
        methods: {
            requestFailure(error) {
                this.processing = false;
                if (error.response && error.response.data) {
                    this.showError(error.response.data.message);
                    return;
                }
                console.log(error);
            },
            showError(message) {
                window.EventHandler.fire('top-warning', {
                    id: 'request-failure',
                    message: message
                });
            }
        }
    }
</script>